import {createFileRoute} from '@tanstack/react-router';
import {MainPage} from '../../../pages';

export const Route = createFileRoute('/_protected/home')({
  component: MainPage,
});
